
/**
 * Fabric Selector
 */
class FabricSelector {

    /**
     * @param undefined|{HTMLElement} elm
     */
    constructor(elm) {
        this.root = elm;

        if (this.root) {
            this.element = this.root.querySelector('.fabric-selector');
            this.radios = this.element.querySelectorAll('input[type="radio"]');
            this.readyToShip = this.element.querySelector('input[name="ready_to_ship"]');

            this.wasPriceElement = this.root.querySelector('.js-product-detail-was-price')
            this.memberWasPriceElement = this.root.querySelector('.js-product-detail-member-was-price')

            this.bind();

            const selected = this.getSelected();

            this.setup(selected);

            this.setGallery(selected.value);
        }
    }

    /**
     * Bind form events
     */
    bind() {
        this.element.querySelectorAll('.js-colour-selection-option').forEach((elm) => elm.addEventListener('click', (e) => {
            e.preventDefault();
            this.onFabricClick(elm);
        }));

        this.radios.forEach((radio) => radio.addEventListener('change', () => this.select(this.getSelected())));

        if (this.readyToShip) {
            this.readyToShip.addEventListener('change', (e) => {
                this.showImmediate(e.currentTarget.checked);
            });
        }
    }

    onFabricClick(elm) {
        const input = elm.querySelector('input[type="radio"]');
        input.checked = !input.checked;
        let event = new Event('change');
        input.dispatchEvent(event);
    }

    /**
     * Get selected radio element
     *
     * @returns {HTMLElement}
     */
    getSelected() {
        for (const element of this.radios) {
            if (element.checked) {
                return element;
            }
        }
    }

    /**
     * On select, update the product details
     *
     * @param {HTMLElement} element
     * @returns
     */
    select(element) {
        if (!element) {
            return;
        }

        this.setup(element);

        this.setGallery(element.value);

        this.setCta(element.dataset.img, element.dataset.name);
    }

    /**
     * Setup the product details
     *
     * @param {*} element
     * @returns
     */
    setup(element) {
        if (!element) {
            return;
        }

        this.setTitle({
            product: element.dataset.productName || '',
            name: element.dataset.name || '',
            material: element.dataset.material || '',
            colour: element.dataset.colour || ''
        });

        this.setPrice(element.dataset.price || '', this.root.querySelector('.js-product-detail-price'));
        this.setPrice(element.dataset.memberPrice || '', this.root.querySelector('.js-product-detail-member-price'));

        if (element.dataset.isDiscounted === 'true') {
            this.wasPriceElement.closest('.product-detail__price ').style.display = '';
            this.memberWasPriceElement.closest('.product-detail__price ').style.display = '';
            this.setPrice(element.dataset.wasPrice || '', this.wasPriceElement);
            this.setPrice(element.dataset.memberWasPrice || '', this.memberWasPriceElement);
        } else {
            if (this.wasPriceElement) {
                this.wasPriceElement.closest('.product-detail__price ').style.display = 'none';
            }
            if (this.memberWasPriceElement) {
                this.memberWasPriceElement.closest('.product-detail__price ').style.display = 'none';
            }
        }

        this.setDescription({
            description: element.dataset.description || '',
            stockitemDescription: element.dataset.stockitemDescription || '',
        });

        this.setConfirmLink(element.value);
    }

    /**
     * Set the product title
     *
     * @param {Object} data
     */
    setTitle(data) {
        const elm = this.root.querySelector('.js-product-detail-title');

        elm.textContent = [
            data.product,
            [
                data.material,
                data.colour
            ].filter(v => !!v).join(' ')
        ].filter(v => !!v).join(' - ');
    }

    /**
     * @param {String} price
     * @param {HTMLElement} element
     */
    setPrice(price, element) {
        if (price < 0) {
            element.closest('.product-detail__prices').style.display = 'none';
        } else {
            element.textContent = price;
        }
    }

    /**
     * Set the description section
     *
     * @param {Object} data
     */
    setDescription(data) {
        const elm = this.root.querySelector('.js-product-detail-fabric-description .richtext');

        elm.innerHTML = data.description || data.stockitemDescription;
    }

    /**
     * Fetch and render the gallery
     *
     * @param {String} productUrl
     */
    setGallery(productUrl) {
        const gallery = this.root.querySelector('.js-fabric-gallery');

        // use http fetch to get the gallery partial
        // then insert it into the overlay
        fetch(`${productUrl}/fabric-overlay-gallery`).then(res => res.text()).then((html) => {
            gallery.innerHTML = html;
        }).catch((error) => {
            console.error('Gallery Error:', error);
        });
    }

    /**
     * Update the CTA
     *
     * @param {String} image The image URL
     * @param {String} name The swatch name
     */
    setCta(image, name) {
        const imgEl = document.querySelector('.js-swatch-img');
        const nameEl = document.querySelector('.js-swatch-name');

        if (imgEl) {
            imgEl.style.backgroundImage = `url(${image})`;
        }

        if (nameEl) {
            nameEl.innerText = name;
        }
    }

    /**
     * Set the url on the fabric confirm button
     *
     * @param {String} productUrl
     */
    setConfirmLink(productUrl) {
        this.root.querySelectorAll('.js-fabric-select-link').forEach((elm) => {
            elm.href = productUrl;
        });
    }

    /**
     * Filter the immediate (to deliver) options
     *
     * @param {boolean} checked
     * @returns
     */
    showImmediate(checked) {
        const immediates = this.element.querySelectorAll('input[data-immediate="1"]');
        if (!immediates.length) {
            return;
        }

        const selectors = this.element.querySelectorAll('.colour-selection');

        for (const selector of selectors) {
            const all = selector.querySelectorAll('input[type="radio"]');
            const targets = selector.querySelectorAll('input[data-immediate="0"]');
            if (targets.length == all.length) {
                selector.style.display = checked ? 'none' : 'inline-grid';
            } else {
                for (const target of targets) {
                    target.parentElement.style.display = checked ? 'none' : 'inline-grid';
                }
            }
        }
    }
}
